<template>
  <div class="supply-detail">
    <div v-if="loading" class="loading-wrap">
      <van-loading type="spinner" color="#4c9673" />
    </div>
    <template v-else>
      <van-cell-group inset title="订单信息">
        <van-cell title="订单号" :value="detail.orderNo || '-'" />
        <van-cell title="订单状态">
          <template #default>
            <span class="status-tag" :class="'status-' + detail.status">
              {{ detail.statusDesc || '-' }}
            </span>
          </template>
        </van-cell>
        <van-cell title="发起状态">
          <template #default>
            <span :class="isPulled ? 'pulled-yes' : 'pulled-no'">
              {{ isPulled ? '已发起' : '未发起' }}
            </span>
          </template>
        </van-cell>
        <van-cell title="商户" :value="detail.merchName || '-'" />
        <van-cell title="店铺类型" :value="detail.merchTypeDesc || '-'" />
        <van-cell title="手机号" :value="detail.phone || '-'" />
        <van-cell title="订单总金额" :value="formatAmount(detail.totalAmount)" />
        <van-cell title="实付金额">
          <template #default>
            <span class="amount">{{ formatAmount(detail.payAmount) }}</span>
          </template>
        </van-cell>
        <van-cell title="支付方式" :value="detail.payChannelDesc || '-'" />
        <van-cell title="预约到货" :value="detail.deliveryTimeDesc || '-'" />
        <van-cell title="是否有售后" :value="detail.hasAfterSale ? '是' : '否'" />
        <van-cell title="状态明细" :label="detail.statusDetail || '-'" />
        <van-cell title="买方备注" :label="detail.buyRemark || '-'" />
        <van-cell title="下单时间" :value="detail.createTime || '-'" />
      </van-cell-group>

      <div class="section-title">
        商品信息
        <span class="section-extra">共 {{ (detail.items || []).length }} 项</span>
      </div>
      <div
        v-for="(item, index) in detail.items || []"
        :key="item.id || index"
        class="product-card"
      >
        <div class="product-card__name">{{ productDisplayName(item) }}</div>
        <div class="product-card__row">
          <span>分类</span>
          <span :class="{ 'category-todo': !item.categoryName }">
            {{ item.categoryName || '待补充' }}
          </span>
        </div>
        <div class="product-card__row">
          <span>商品编号</span>
          <span>{{ item.productCode || '-' }}</span>
        </div>
        <div class="product-card__row">
          <span>69条码</span>
          <span>{{ item.barCode || '-' }}</span>
        </div>
        <div v-if="item.spec" class="product-card__row">
          <span>规格</span>
          <span>{{ item.spec }}</span>
        </div>
        <div class="product-card__row">
          <span>单价</span>
          <span>{{ formatAmount(item.actualUnitPrice) }}</span>
        </div>
        <div class="product-card__row">
          <span>数量</span>
          <span>{{ item.quantity ?? '-' }}</span>
        </div>
        <div class="product-card__row">
          <span>小计</span>
          <span class="amount">{{ formatAmount(item.payAmount || item.totalAmount) }}</span>
        </div>
      </div>

      <div v-if="!((detail.items || []).length)" class="empty-tip">暂无商品</div>

      <div class="footer-placeholder" />
      <div v-if="canPull" class="footer">
        <van-button block type="primary" color="#4c9673" @click="goInbound">
          发起入库
        </van-button>
      </div>
    </template>
  </div>
</template>

<script>
import { getWholesaleOrder } from '../../../service/api/purchase/supply'

const STATUS_FINISHED = 4

export default {
  name: 'supply-detail',
  data() {
    return {
      loading: false,
      detail: {},
    }
  },
  computed: {
    isPulled() {
      const pulledFromQuery = this.$route.query.pulled
      return (
        this.detail.pulled === true ||
        this.detail.pulled === 1 ||
        pulledFromQuery === '1'
      )
    },
    canPull() {
      // 详情接口不一定返回 pulled，优先用路由参数兜底
      return this.detail.status === STATUS_FINISHED && !this.isPulled
    },
  },
  mounted() {
    this.loadDetail()
  },
  methods: {
    formatAmount(amount) {
      if (amount === null || amount === undefined || amount === '') return '-'
      return `¥${Number(amount).toFixed(2)}`
    },
    productDisplayName(item) {
      if (!item) return '-'
      const brand = item.brandName ? `【${item.brandName}】` : ''
      return brand + (item.productName || '-')
    },
    loadDetail() {
      const id = this.$route.params.id
      if (!id) return
      this.loading = true
      getWholesaleOrder(id)
        .then((res) => {
          this.detail = res.data || {}
        })
        .finally(() => {
          this.loading = false
        })
    },
    goInbound() {
      this.$router.push({
        path: '/purchase/supplyInbound',
        query: { orderNo: this.detail.orderNo },
      })
    },
  },
}
</script>

<style lang="less" scoped>
.supply-detail {
  min-height: 100%;
  background: #f5f5f5;
  padding-bottom: 12px;
}

.loading-wrap {
  padding-top: 80px;
  text-align: center;
}

.amount {
  color: #ff4d4f;
  font-weight: 600;
}

.pulled-yes {
  color: #4c9673;
}

.pulled-no {
  color: #ff4d4f;
}

.status-tag {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 10px;
  color: #fff;
  font-size: 12px;
  background: #858585;

  &.status-4 {
    background: #4c9673;
  }
  &.status-5 {
    background: #cf1322;
  }
  &.status-1,
  &.status-2 {
    background: #1677ff;
  }
  &.status-3 {
    background: #fa8c16;
  }
}

.section-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 12px 16px 8px;
  font-size: 14px;
  font-weight: 600;
  color: #262626;

  .section-extra {
    font-size: 12px;
    font-weight: 400;
    color: #8c8c8c;
  }
}

.product-card {
  margin: 0 12px 8px;
  padding: 12px;
  background: #fff;
  border-radius: 8px;

  &__name {
    font-size: 14px;
    font-weight: 600;
    color: #262626;
    margin-bottom: 8px;
    line-height: 1.4;
  }

  &__row {
    display: flex;
    justify-content: space-between;
    margin-top: 6px;
    font-size: 13px;
    color: #595959;

    > span:first-child {
      color: #8c8c8c;
      flex-shrink: 0;
      margin-right: 12px;
    }

    > span:last-child {
      text-align: right;
      word-break: break-all;
    }
  }
}

.category-todo {
  color: #d48806;
}

.empty-tip {
  padding: 24px;
  text-align: center;
  color: #999;
  font-size: 13px;
}

.footer-placeholder {
  height: 70px;
}

.footer {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 10px 16px;
  background: #fff;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.06);
}

::v-deep .van-cell-group__title {
  padding-top: 12px;
}
</style>
